export const VAULT_LIST_REFETCH_INTERVAL = 15000;
